import { createContext } from 'react'

export type DeprecationContext = {
	showDeprecated: boolean
	hasDeprecated: boolean
	toggleShowDeprecated: () => void
	registerDeprecated: () => void
}

export const deprecationContext = createContext<DeprecationContext | undefined>(undefined)
